import { CheckCircle2, XCircle } from "lucide-react";
import { fmtDate } from "./shared";

export default function VerificationResult({ r, test = false }) {
  const s = r.signature || {};
  return (
    <div className="space-y-3" data-testid="ag-verification-result">
      <div className={`rounded-lg border p-3 font-bold text-sm ${r.ok ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-300" : "border-red-500/40 bg-red-500/10 text-red-300"}`} data-testid="ag-verification-verdict">
        {test ? (r.ok ? "Test passed — your USB token works with Karmivo" : "Test failed — fix the items below and try again") : r.ok ? "Digitally Signed – Verified" : "Verification failed — agreement NOT marked as signed"}
      </div>
      <ul className="space-y-1">
        {(r.checks || []).map((c) => (
          <li key={c.key} className="flex gap-2 text-xs" data-testid={`ag-check-${c.key}`}>
            {c.ok ? <CheckCircle2 size={14} className="text-emerald-400 shrink-0 mt-0.5"/> : <XCircle size={14} className="text-red-400 shrink-0 mt-0.5"/>}
            <span className={c.ok ? "text-slate-300" : "text-red-200"}>{c.label}{!c.ok && c.detail ? ` — ${c.detail}` : ""}</span>
          </li>
        ))}
      </ul>
      {s.subject_cn && (
        <div className="grid grid-cols-[120px_1fr] gap-y-1 gap-x-2 text-xs">
          <span className="text-slate-500">Signer</span><span>{s.subject_cn}</span>
          <span className="text-slate-500">Issuer (CA)</span><span>{s.issuer_cn}</span>
          <span className="text-slate-500">Serial</span><span className="font-mono">{s.serial}</span>
          <span className="text-slate-500">Signing time</span><span>{fmtDate(s.signing_time)}</span>
          <span className="text-slate-500">Trusted timestamp</span><span>{s.timestamp_time ? fmtDate(s.timestamp_time) : "none"}</span>
          <span className="text-slate-500">CA chain</span><span>{s.chain_trusted == null ? "not checked (no CA certs uploaded)" : s.chain_trusted ? "trusted" : "not trusted"}</span>
          <span className="text-slate-500">Cert valid to</span><span>{fmtDate(s.valid_to)}</span>
        </div>
      )}
    </div>
  );
}
